import styled from 'styled-components';
import buttonDefaultStyle from 'components/mixins/normalize';
import { reviewFontText } from 'components/mixins/reviewTypography';
import { crossFade, transition } from 'components/mixins/interactivity';
import media from 'components/mixins/media';
import { centerAbsoluteElementY } from 'components/mixins/placement';
import { transparentize } from 'utils/color';
import Icon from 'components/common/Icon';

export const CommentFormContainer = styled.div`
  width: 100%;
`;

export const FormWrapper = styled.form`
  ${reviewFontText};
  min-height: 285px;
  max-height: 356px;
`;

export const SubmitIcon = styled(Icon)`
  margin: 0 5px 0 17px;
  top: 1px;
`;

export const FormContent = styled.div`
  min-height: 285px;
  background: ${props => props.theme.colors.contentBodyColor};
  padding: 22px 14px 22px 16px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 430px;

  ${media.mobile`
    width: 300px;
  `};
`;

export const FormActions = styled.div`
  align-self: flex-end;
  padding-top: 16px;
`;

type FormSubmitButtonProps = {
  tabIndex: number;
  disabled: any;
  onClick: any;
  onKeyDown: any;
};
export const FormSubmitButton = styled.button<FormSubmitButtonProps>`
  ${buttonDefaultStyle};
  position: relative;
  background: #4caf50;
  border-radius: 16px;
  padding: 10px 20px 10px 0;
  color: #fff;
  font-size: 11px;
  line-height: 11px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px 0 ${transparentize('#000000', 0.2)};
  ${transition(0.3)};

  &:hover,
  &:focus {
    background: #46a14a;
  }

  &:disabled:before {
    background-color: rgba(255, 255, 255, 0.3);
    content: '';
    cursor: not-allowed;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

export const FormCancelButton = styled.button`
  ${buttonDefaultStyle};
  font-size: 11px;
  font-weight: 600;
  color: #99a9b8;
  cursor: pointer;
  margin-left: 10px;

  &:hover,
  &:focus {
    color: #81c884;
  }
`;

export const SuccessMessageIcon = styled(Icon)`
  ${centerAbsoluteElementY};
  left: 8px;
  color: #4caf50;
  line-height: 7px;
  position: absolute;
`;

export const ErrorMessageIcon = styled.div`
  ${centerAbsoluteElementY};
  left: 12px;
  color: #4caf50;
  position: absolute;
  font-size: 16px;
  font-weight: bold;
`;

export const SuccessMessage = styled.div`
  ${reviewFontText};
  line-height: 17px;
  padding: 7px 13px 7px 27px;
  background: #f6fbf7;
  border-radius: 3px;
  border: solid 1px #d3ecd4;
  ${crossFade('fromRight')};
  margin-top: 16px;
  position: relative;
  align-self: flex-end;
`;

export const ErrorMessage = styled(SuccessMessage)`
  background: rgba(248, 93, 103, 0.1);
  border: solid 1px rgba(248, 93, 103, 0.3);
`;
